import { Popover } from 'antd';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { useStoreNameConfig } from 'hooks/business/store/useStoreName';
import moreSvg from 'views/Aide/assets/more.svg';

export interface AppliedStoreItem {
  storeId?: string | number;
  storeName?: string;
  alias?: string;
  externalType?: string;
  region?: string;
}

export interface AppliedStoresProps {
  count: number;
  storeInfo: AppliedStoreItem[];
}

const Trigger = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  > img {
    width: 16px;
    height: 16px;
    display: block;
  }
`;

const List = styled.ul`
  max-width: 325px;
  max-height: 200px;
  margin: -12px -16px;
  padding: 12px 16px;
  list-style: none;
  overflow-x: hidden;
  overflow-y: auto;

  > li {
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

function AppliedStores(props: AppliedStoresProps) {
  const { count, storeInfo } = props;
  const { t } = useTranslate();
  const { configMap: storeNameConfigMap } = useStoreNameConfig();

  const storeList = storeInfo.map((store, index) => {
    const { externalType = '', region = '' } = store;
    const { [externalType]: { [region]: isStoreAliasFirst = true } = {} } = storeNameConfigMap;

    return {
      id: store.storeId ?? `${store.storeName ?? store.alias ?? 'store'}-${index}`,
      storeName: store.storeName ?? '',
      alias: store.alias ?? '',
      isStoreAliasFirst,
    };
  });

  const content = (
    <List>
      {storeList.map(({ id, alias, storeName, isStoreAliasFirst }) => (
        <li key={id}>{isStoreAliasFirst ? alias || storeName : storeName}</li>
      ))}
    </List>
  );

  return (
    <Popover placement="bottom" content={content}>
      <Trigger data-sid="bc-appliedstores-52">
        <span
          className="whitespace-nowrap"
          style={{ color: '#515359', fontSize: 14, fontWeight: 500, lineHeight: '20px' }}
        >
          {t('scene.aiAgentConfig.scenarioDetail.appliedStores', { x: count })}
        </span>
        <img src={moreSvg} alt="more" />
      </Trigger>
    </Popover>
  );
}

export default AppliedStores;
